module.exports = __webpack_public_path__ + "static/media/297452.859cb712.png";